import { Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { useVersion } from 'mir-utils/api-tools';
import { Loading } from 'mir-utils/components';
import { IconLogo } from 'mir-utils/components/IconLogo';
import { useMobileMatch } from 'mir-utils/hooks';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      borderRadius: ({ mobileVersion }: { mobileVersion?: boolean }) =>
        mobileVersion ? '' : `${theme.spacing(0.5)} ${theme.spacing(0.5)} 0px 0px`,
      padding: theme.spacing(4, 0),
      backgroundColor: theme.palette.primary.main,
    },
    headerText2Part: {
      color: theme.palette.primary.contrastText,
    },
  })
);

export const Logo = () => {
  const version = useVersion();

  if (version === undefined) {
    return <Loading />;
  }

  return <IconLogo path={`${process.env.PUBLIC_URL}/${version.logoPath}`} />;
};

export const Header = () => {
  const mobileVersion = useMobileMatch();
  const { header } = useStyles({ mobileVersion });
  return (
    <Box display="flex" justifyContent="center" width="100%" alignItems="center" className={header}>
      <Logo />
    </Box>
  );
};
